import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';

import Layout from '../../Layout';
import SelectBox from '../../shared/select-boxes/SelectBox';
import VideoComponent from '../../shared/VideoComponent';
import ContinentsPopup from './ContinentsPopup';
import ButtonBack from '../../shared/buttonComponents/ButtonBack';
import { useHistory } from 'react-router-dom';

export const ContinentsPage: FC = () => {
  const {
    changeStep,
    updateStepData,
    staticData
  } = useWizard();


  const [selected, setSelected] = useState<string>('');
  const pageRef = useRef(null);

  const continentCountriesMap = useMemo(() => {
    return staticData.countries.reduce((acc, country) => {
      const item = {
        name: country.name,
        tier: country.tier,
        selected: false
      };

      if (acc[country.continent]) {
        acc[country.continent].push(item);
      } else {
        acc[country.continent] = [item];
      }
      return acc;
    }, {
      'North America': [],
      'Europe': [],
      'Asia': [],
      'Central America': [],
      'Africa': [],
      'Middle East': [],
      'South America': [],
      'The Caribbean': [],
      'Oceania': []
    } as { [key: string]: { name: string, tier: string, selected: boolean }[] });
  }, [staticData.countries]);

  const handleSubmit = useCallback((country) => {
    updateStepData({
      continent: selected,
      countries: country.name,
      countryTier: country.tier,
    });
    setSelected('');

      changeStep(WizardStep.INDUSTRY);

  }, [selected, updateStepData, setSelected, changeStep]);

  const handleSelect = useCallback((continent) => {
    if (pageRef.current) {
      // @ts-ignore
      pageRef.current.scrollTo(0, 0);
    }

    setSelected(continent);
  }, [setSelected]);

  let history = useHistory();
// use destructuring to access the history property of the ReactComponentProps type

  useEffect(() => {

    return () => {
      if (history.action === 'POP') {
        // Code here will run when back button fires.
        // Note that it's after the `return` for useEffect's callback;
        // code before the return will fire after the page mounts,
        // code after when it is about to unmount.
        changeStep(WizardStep.REGION);
      }
    };
  });


  return (
    <Layout refE={pageRef}>
      <div className="continents-page-container">
        {selected && (
          <ContinentsPopup
            onClose={() => setSelected('')}
            onSubmit={handleSubmit}
            continent={selected}
            countriesList={continentCountriesMap[selected] || []}
          />
        )}
        <div className="continents-page-globe">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/globe.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/globus.png`}
          />
        </div>
        <div className="continents-page-left">
          <div className="secondary-title">Almost done...</div>
          <div className="main-title">Where is your <br/>company based?</div>
          <div className="continents-page-list">
            {Object.keys(continentCountriesMap).map((continent) => (
              <SelectBox
                key={continent}
                onClick={() => handleSelect(continent)}
                icon={`continents/${continent.toLocaleLowerCase().replace(/\\s/g, '-')}`}
                title={continent}
              />
            ))}
          </div>

          <div className='continents-page-button'>
            <ButtonBack
              disabled={false}
              onClick={() => changeStep(WizardStep.REGION)}
              title="Back"
            />
          </div>

        </div>


        <div className="continents-page-right">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/globe.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/globus.png`}
          />
        </div>
      </div>
    </Layout>
  );
};
